import { translate, configQuery, isMobileQuery } from '@gig/magic-common';
import { __awaiter, __generator, __assign } from 'tslib';
import { magic } from '@gig/magic-sdk';
import { USER_PROFILE_DATA } from '@gig/magic-messages';
import { notificationService, NotificationStyle } from '@gig/magic-messaging';
import { alpha2ToAlpha3 } from './nationalities.js';

function launchScanVerification(documentType) {
    if (documentType === void 0) { documentType = 'photoID'; }
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(documentType === 'address')) return [3 /*break*/, 2];
                    return [4 /*yield*/, ac9124AddressVerificationFlow()];
                case 1: return [2 /*return*/, _a.sent()];
                case 2: return [4 /*yield*/, photoIDVerificationFlow()];
                case 3: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function ac9124AddressVerificationFlow() {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var user, profileData, config, overlay, popStateHandler, ac9124;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    user = magic.session.getUser();
                    return [4 /*yield*/, window.queryBus.query(USER_PROFILE_DATA)];
                case 1:
                    profileData = _b.sent();
                    if (!(user === null || user === void 0 ? void 0 : user.id)) {
                        return [2 /*return*/];
                    }
                    if (!(profileData === null || profileData === void 0 ? void 0 : profileData.consents)) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, configQuery('scanVerificationAddress')];
                case 2:
                    config = _b.sent();
                    return [4 /*yield*/, injectAc9124Sdk()];
                case 3:
                    _b.sent();
                    return [4 /*yield*/, createIframeContainer()];
                case 4:
                    overlay = _b.sent();
                    popStateHandler = function () {
                        removeContainer(overlay);
                        window.removeEventListener('popstate', popStateHandler);
                    };
                    window.history.pushState({ ac9124ModalOpen: true }, '');
                    window.addEventListener('popstate', popStateHandler);
                    ac9124 = new window.AC9124();
                    ac9124.init({
                        merchantkey: (_a = config === null || config === void 0 ? void 0 : config.merchantKey) !== null && _a !== void 0 ? _a : '',
                        name: user === null || user === void 0 ? void 0 : user.firstName,
                        surname: user === null || user === void 0 ? void 0 : user.lastName,
                        street: profileData.user.address.streetAddress,
                        city: profileData.user.address.addressLocality,
                        postcode: profileData.user.address.postalCode,
                        country: alpha2ToAlpha3[profileData.user.address.addressCountry],
                        countrycode: profileData.user.address.addressCountry,
                        reference: user === null || user === void 0 ? void 0 : user.id,
                        onInit: function (data) {
                            // eslint-disable-next-line no-console
                            console.log('AC9124 init', data);
                        },
                        onComplete: function (data) {
                            // eslint-disable-next-line no-console
                            console.log('AC9124 complete', data);
                            window.dispatchEvent(new CustomEvent('address-scan-complete', {
                                bubbles: true,
                                detail: data,
                            }));
                            removeContainer(overlay);
                            window.removeEventListener('popstate', popStateHandler);
                        },
                        onFail: function (data) {
                            console.error('AC9124 fail', data);
                            notificationService.show(translate('file-upload.verification.scan.address.failed'), {
                                style: NotificationStyle.ERROR,
                                uniqueID: 'verification-upload-error',
                            });
                            removeContainer(overlay);
                        },
                    });
                    return [2 /*return*/];
            }
        });
    });
}
function photoIDVerificationFlow() {
    return __awaiter(this, void 0, void 0, function () {
        var token, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, magic.session.getAccessToken()];
                case 1:
                    token = _a.sent();
                    return [4 /*yield*/, magic.methods.users.getUserVerificationURL({
                            actionId: 'AC0130',
                            token: token,
                        })];
                case 2:
                    response = _a.sent();
                    if (!(response === null || response === void 0 ? void 0 : response.url)) {
                        throw new Error('Verification URL is null');
                    }
                    return [2 /*return*/, response.url];
            }
        });
    });
}
function createIframeContainer() {
    return __awaiter(this, void 0, void 0, function () {
        var isMobile, config, overlay, iframeContainer, loader, closeButton;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, isMobileQuery()];
                case 1:
                    isMobile = _a.sent();
                    return [4 /*yield*/, configQuery('scanVerificationAddress')];
                case 2:
                    config = _a.sent();
                    overlay = createOverlay();
                    iframeContainer = createIframeContainerElement(config === null || config === void 0 ? void 0 : config.iframeStyles);
                    loader = createLoader(config === null || config === void 0 ? void 0 : config.loaderStyles);
                    closeButton = createCloseButton(isMobile, config === null || config === void 0 ? void 0 : config.iframeCloseButtonStyles, overlay);
                    overlay.appendChild(iframeContainer);
                    document.body.appendChild(overlay);
                    document.body.appendChild(loader);
                    injectLoaderKeyframesIfNeeded(config === null || config === void 0 ? void 0 : config.loaderStyles);
                    setTimeout(function () { return loader.remove(); }, 4000);
                    setTimeout(function () { return overlay.appendChild(closeButton); }, 4000);
                    return [2 /*return*/, overlay];
            }
        });
    });
}
function createOverlay() {
    var overlay = document.createElement('div');
    overlay.id = 'ac-overlay';
    Object.assign(overlay.style, {
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        zIndex: '9998',
    });
    return overlay;
}
function createIframeContainerElement(styles) {
    if (styles === void 0) { styles = {}; }
    var iframeContainer = document.createElement('div');
    iframeContainer.id = 'ac-component';
    Object.assign(iframeContainer.style, __assign({ width: '100%', height: '100%', alignContent: 'center' }, styles));
    return iframeContainer;
}
function createLoader(loaderStyles) {
    var _a, _b;
    if (loaderStyles === void 0) { loaderStyles = {}; }
    var loader = document.createElement('div');
    loader.className = 'custom-loader';
    loader.innerHTML = "<div class=\"spinner\"></div>";
    var defaultLoaderStyles = {
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: '9999',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    };
    var defaultSpinnerStyles = {
        width: '48px',
        height: '48px',
        border: '5px solid rgba(255, 255, 255, 0.3)',
        borderTopColor: '#fff',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
    };
    Object.assign(loader.style, defaultLoaderStyles, (_a = loaderStyles === null || loaderStyles === void 0 ? void 0 : loaderStyles.container) !== null && _a !== void 0 ? _a : {});
    var spinner = loader.querySelector('.spinner');
    if (spinner) {
        Object.assign(spinner.style, defaultSpinnerStyles, (_b = loaderStyles === null || loaderStyles === void 0 ? void 0 : loaderStyles.spinner) !== null && _b !== void 0 ? _b : {});
    }
    return loader;
}
function injectLoaderKeyframesIfNeeded(loaderStyles) {
    var _a;
    if (loaderStyles === void 0) { loaderStyles = {}; }
    var shouldInject = !((_a = loaderStyles === null || loaderStyles === void 0 ? void 0 : loaderStyles.spinner) === null || _a === void 0 ? void 0 : _a.animation) &&
        !document.getElementById('ac-loader-style');
    if (shouldInject) {
        var style = document.createElement('style');
        style.id = 'ac-loader-style';
        style.textContent = "\n            @keyframes spin {\n                to { transform: rotate(360deg); }\n            }\n        ";
        document.body.appendChild(style);
    }
}
function createCloseButton(isMobile, styles, overlay) {
    if (styles === void 0) { styles = {}; }
    var button = document.createElement('button');
    button.textContent = '×';
    var defaultButtonStyles = {
        position: 'fixed',
        top: '9px',
        right: isMobile ? '55px' : '10px',
        zIndex: '10000',
        backgroundColor: '#fff',
        color: 'rgba(0, 0, 0, 0.75)',
        border: '1px solid #E6E6E6',
        borderRadius: '100%',
        width: '32px',
        height: '32px',
        fontSize: '24px',
        cursor: 'pointer',
    };
    var responsiveOverride = isMobile ? styles.mobile : styles.desktop;
    Object.assign(button.style, defaultButtonStyles, styles, responsiveOverride);
    button.addEventListener('click', function () {
        removeContainer(overlay);
        window.history.back();
    });
    return button;
}
function removeContainer(overlay) {
    if (overlay && document.body.contains(overlay)) {
        document.body.removeChild(overlay);
    }
    var loader = document.querySelector('.custom-loader');
    if (loader && document.body.contains(loader)) {
        loader.remove();
    }
}
function injectAc9124Sdk() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var existingScript = document.querySelector('script[src*="getsdk"]');
                    if (existingScript) {
                        resolve();
                        return;
                    }
                    var script = document.createElement('script');
                    script.src =
                        'https://staging.agechecked.com/api/acapiremote/ac9124/v1/getsdk';
                    script.onload = function () { return resolve(); };
                    script.onerror = reject;
                    document.head.appendChild(script);
                })];
        });
    });
}
function initScanVerificationPolling(verificationURL, openInSameTab, safariWindow) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    if (!verificationURL) {
                        console.error('Error: response is null or does not contain a URL');
                        return reject();
                    }
                    if (openInSameTab) {
                        window.location.href = verificationURL;
                        return resolve();
                    }
                    // Use Safari pre-opened window or open new tab
                    var newTab = safariWindow && !safariWindow.closed
                        ? ((safariWindow.location.href = verificationURL), safariWindow)
                        : window.open(verificationURL, '_blank');
                    var checkInterval = setInterval(function () {
                        var urlParams = new URLSearchParams(window.location.search);
                        if (urlParams.get('scan-verification') === 'complete' ||
                            (newTab && newTab.closed)) {
                            clearInterval(checkInterval);
                            resolve();
                        }
                    }, 1000);
                })];
        });
    });
}

export { initScanVerificationPolling, launchScanVerification };
